import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationComponent } from './application.component';
import { AuthGuard } from '../../shared/auth/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '', component: ApplicationComponent, children: [
          {
            path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), runGuardsAndResolvers: 'always', canActivate: [AuthGuard]
          },
          {
            path: 'workforce', loadChildren: () => import('./workforce/workforce.module').then(m => m.WorkforceModule), runGuardsAndResolvers: 'always', canActivate: [AuthGuard]
          },
          {
            path: 'timesheet', loadChildren: () => import('./timesheet/timesheet.module').then(m => m.TimesheetModule), runGuardsAndResolvers: 'always', canActivate: [AuthGuard]
          },
          {
            path: 'report', loadChildren: () => import('./report/report.module').then(m => m.ReportModule), runGuardsAndResolvers: 'always', canActivate: [AuthGuard]
          },
          {
            path: 'planner', loadChildren: () => import('./planner/planner.module').then(m => m.PlannerModule), runGuardsAndResolvers: 'always', canActivate: [AuthGuard]
          }
        ]
      }
    ]
    )],
  exports: [
    RouterModule
  ]
})
export class ApplicationRoutingModule { }
